<template>
    <div class="flex flex-wrap -mx-6">
        <div class="lg:w-3/12 w-full px-6">
            <section class="w-full lg:pt-16">
                <div class="">
                    <div id="filter-sidebar" class="w-full bg-primary-500 rounded-2xl items-center text-center  p-5">
                        <d-field label="">
                            <d-input v-model="filter" class="bg-input rounded-2xl text-right" placeholder="Search By Name" icon="search" />
                        </d-field>
                        <d-btn block class="lg:hidden" @click="showMobileFilters = !showMobileFilters">
                            Show Advanced Filters
                        </d-btn>
                        <div class="pb-4 pt-1 text-left">
                            <div>
                                <d-checkbox v-model="notCompletedOnly" class="ml-2 py-1 pt-1 font-bold text-white" white-checkmark>
                                    Hide Completed Lessons
                                </d-checkbox>
                            </div>
                            <div >
                                <d-checkbox v-model="favoritesOnly" class="ml-2 py-1 font-bold text-white" white-checkmark>
                                    Show Favorites Only
                                </d-checkbox>
                            </div>
                        </div>

                        <div class="pb-4 pt-1">
                            <d-select v-model="sortValue" expanded @update:modelValue="val => setSort(val)">
                                <option value="order">
                                    Default Sort
                                </option>
                                <option value="name">
                                    Sort By Title
                                </option>
                                <option value="createdAt">
                                    Sort By Creation Date
                                </option>
                            </d-select>
                        </div>

                        <div class="hidden lg:block">
                            <filter-accordion v-if="resourceTypes.length > 0" title="Resource Type">
                                <d-checkbox v-for="resourceType in resourceTypes" :key="resourceType.id" v-model="resourceTypeFilters" :native-value="resourceType.id" class="ml-2 py-1 pt-1 font-bold" white-checkmark>
                                    <div class="flex items-start">
                                        <d-icon :icon="resourceType.imageUrl" pack="fad" class="pl-1 pr-2 text-green flex-shrink-0 mt-1" />
                                        <span class="break-words">{{ resourceType.name }}</span>
                                    </div>
                                </d-checkbox>
                            </filter-accordion>
                            <filter-accordion v-if="categories.length > 0" title="Category" class="mt-4">
                                <d-checkbox v-for="category in categories" :key="category.id" v-model="categoryFilters" @update:modelValue="updateHomeCategoryFilters(category.id, $event)" class="ml-2 py-1 pt-1 font-bold" white-checkmark :native-value="category.id">
                                    <div class="flex items-start">
                                        <d-icon :icon="category.imageUrl" pack="fad" class="pl-1 pr-2 text-secondary-500 flex-shrink-0 mt-1" />
                                        <span class="break-words">{{ category.name }}</span>
                                    </div>
                                </d-checkbox>
                            </filter-accordion>
                        </div>
                        <d-expand-transition v-show="showMobileFilters" class="lg:hidden">
                            <div>
                                <filter-accordion v-if="resourceTypes.length > 0" title="Resource Type" class="mt-3">
                                    <d-checkbox v-for="resourceType in resourceTypes" :key="resourceType.id" v-model="resourceTypeFilters" :native-value="resourceType.id" class="ml-2 py-1 pt-1 font-bold" white-checkmark>
                                        <div class="flex items-start">
                                            <d-icon :icon="resourceType.imageUrl" pack="fad" class="pl-1 pr-2 text-green flex-shrink-0 mt-1" />
                                            <span class="break-words">{{ resourceType.name }}</span>
                                        </div>
                                    </d-checkbox>
                                </filter-accordion>
                                <filter-accordion v-if="categories.length > 0" title="Category" class="mt-4">
                                    <d-checkbox v-for="category in categories" :key="category.id" v-model="categoryFilters" @update:modelValue="updateHomeCategoryFilters(category.id, $event)" class="ml-2 py-1 pt-1 font-bold" white-checkmark :native-value="category.id">
                                        <div class="flex items-start">
                                            <d-icon :icon="category.imageUrl" pack="fad" class="pl-1 pr-2 text-secondary-500 flex-shrink-0 mt-1" />
                                            <span class="break-words">{{ category.name }}</span>
                                        </div>
                                    </d-checkbox>
                                </filter-accordion>
                            </div>
                        </d-expand-transition>
                    </div>
                </div>
            </section>
        </div>
        <div class="lg:w-2/3 w-full lg:pt-0 pt-12 px-6">
            <p class="mb-0">
                <a href="/" class="font-bold">Back to All Programs</a>
            </p>
            <h1 class="font-bold text-center md:text-left mt-0">
                {{ serviceArea.name }}
            </h1>
            <section>
                <div class="w-full  lg:mt-4 lg:mb-10 lg:pb-0 pb-5">
                    <div v-if="loading" class="flex justify-center py-10">
                        <d-loader />
                    </div>
                    <div v-else class="flex flex-wrap md:-mx-5">
                        <div v-for="listing in filteredContentListings" :key="listing.id" class="lg:w-1/3 md:w-1/2 w-full px-2 md:px-5 pt-2 pb-10" @click="goToUrl(`/content/${listing.id}`)">
                            <div class="inset-0  bg-purple rounded-3xl relative  lg:h-40 h-48 cursor-pointer flex justify-center items-center select-none">
                                <cost-status-chip :content="listing" />
                                <div class=" text-white text-2xl font-bold text-center p-4" style="text-shadow: 0 0 15px #000">
                                    {{ listing.name }}
                                </div>
                                <div v-if="listing.categories.length > 0 || listing.resourceTypes.length > 0" class="shadow-lg bg-white rounded-full px-5 py-4 absolute bottom-0 font-bold -mb-8 w-10/12">
                                    <div class="flex  items-center justify-center  text-lg">
                                        <d-tooltip v-for="category in listing.categories" :key="`category-${category.id}`" :label="category.name" position="bottom">
                                            <d-icon :icon="category.imageUrl" class="text-secondary-400 px-2" pack="fad" />
                                        </d-tooltip>
                                        <d-tooltip v-for="resourceType in listing.resourceTypes" :key="`resource-${resourceType.id}`" :label="resourceType.name" position="bottom">
                                            <d-icon :icon="resourceType.imageUrl" class="text-green px-2" pack="fad" />
                                        </d-tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div class="flex justify-end">
                <d-pagination :total-items="total" :per-page="pagination.pageSize" v-model:current="pagination.page" />
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import debounce from 'lodash/debounce';
    import FilterAccordion from './components/FilterAccordion.vue';

    export default {
        parent: true,
        components: {
            FilterAccordion,
        },

        props: {
            serviceArea: {
                type: Object,
                default: () => ({}),
            },
        },

        data() {
            return {
                loading: true,
                showMobileFilters: false,
                notCompletedOnly: false,
                favoritesOnly: false,
                categories: [],
                resourceTypes: [],
                contentListings: [],
                resourceTypeFilters: [],
                categoryFilters: [],
                filter: '',
                total: 0,
                categoryNameToIdMap: new Map(),
                sortValue: 'order', // Add reactive property for sort value
                pagination: {
                    page: 1,
                    pageSize: 18,
                    sortField: 'order',
                    sortOrder: 'asc',
                },
                mountedInit: false, // Flag to prevent initial double fetching
            };
        },

        watch: {
            pagination: {
                handler() {
                    if (this.mountedInit) this.getListingsPaged();
                },
                deep: true,
            },

            filter() {
                if (this.mountedInit) {
                    this.loading = true;
                    this.getDebouncedListingsPaged();
                }
            },

            notCompletedOnly() {
                if (this.mountedInit) this.getListingsPaged();
            },

            favoritesOnly() {
                if (this.mountedInit) this.getListingsPaged();
            },

            resourceTypeFilters: {
                handler(newValue) {
                    if (this.mountedInit) {
                        this.saveFilters();
                        this.loading = true;
                        this.getDebouncedListingsPaged();
                    }
                },
                deep: true,
            },

            categoryFilters: {
                handler(newValue) {
                    if (this.mountedInit) {
                        this.saveFilters(); 
                        this.loading = true;
                        this.getDebouncedListingsPaged();
                    }
                },
                deep: true,
            },
        },

        computed: {
            filteredContentListings() {
                return this.contentListings.filter(listing => {
                    if (this.categoryFilters.length > 0) {
                        return listing.categories.some(category => this.categoryFilters.includes(category.id));
                    }
                    return true;
                });
            }
        },

        async mounted() {
            await this.loadFilters();
            await this.fetchResourceTypes();
            await this.fetchCategories(); 
            await this.getListingsPaged();
            this.mountedInit = true;
        },

        methods: {
            async setSort(sort) {
                this.sortValue = sort; // Update the reactive sort value
                this.pagination.sortField = sort;
                this.pagination.sortOrder = sort === 'createdAt' ? 'desc' : 'asc';
                if (this.mountedInit) await this.getListingsPaged();
            },

            async fetchCategories() {
                const { data } = await axios.get(`/api/subject-areas/${this.serviceArea.id}/categories`);
                this.categories = data;

                // Build the name-to-id mapping
                this.categoryNameToIdMap = new Map(
                    data.map(category => [category.name.toLowerCase(), category.id])
                );

                // Now that we have the mapping, we can properly initialize filters
                this.initializeCategoryFilters();
            },

            initializeCategoryFilters() {
                try {
                    // First load any previously saved filters for this specific page
                    const savedPageFiltersStr = localStorage.getItem(`categoryFilters-${this.serviceArea.id}`);
                    const savedPageFilters = savedPageFiltersStr ? JSON.parse(savedPageFiltersStr) : [];

                    // Then load and process home page filters
                    const homeFiltersStr = localStorage.getItem('home-categoryFilters');
                    const homeFilters = homeFiltersStr ? JSON.parse(homeFiltersStr) : [];

                    // Convert home category names to IDs where possible
                    const homeFilterIds = homeFilters
                        .map(categoryName => {
                            const category = this.categories.find(c =>
                                c.name.toLowerCase() === categoryName.toLowerCase()
                            );
                            return category ? category.id : null;
                        })
                        .filter(id => id !== null);

                    // Combine both sets of filters, ensuring all values are numbers
                    const combinedFilters = [...savedPageFilters, ...homeFilterIds]
                        .map(id => typeof id === 'string' ? parseInt(id, 10) : id)
                        .filter(id => !isNaN(id));

                    // Remove duplicates and set the filters
                    this.categoryFilters = [...new Set(combinedFilters)];

                    // Save the combined filters
                    this.saveFilters();
                } catch (error) {
                    console.error('Error initializing category filters:', error);
                    this.categoryFilters = [];
                }
            },


            async fetchResourceTypes() {
                const { data } = await axios.get(`/api/subject-areas/${this.serviceArea.id}/resource-types`);
                this.resourceTypes = data;
            },

            async getListingsPaged() {
                const { page, sortField, sortOrder, pageSize } = this.pagination;
                this.loading = true;
                // When sortField is 'order' (Default Sort), send empty sortDir so the server
                // determines the correct default sort based on the program area's configuration
                const sortDir = sortField === 'order' ? '' : `${sortField} ${sortOrder}`;
                const params = [
                    `filter=${this.filter}`,
                    `sortDir=${sortDir}`,
                    `currentPage=${page}`,
                    `pageSize=${pageSize}`,
                    `categoryIds=${this.categoryFilters}`,
                    `resourceTypeIds=${this.resourceTypeFilters}`,
                    `notCompletedOnly=${this.notCompletedOnly}`,
                    `favoritesOnly=${this.favoritesOnly}`,
                ].join('&');
                const { data } = await axios.get(`/api/subject-areas/${this.serviceArea.id}/content-listings?${params}`);
                this.contentListings = data.resultItems;
                this.total = data.totalRecords;
                this.loading = false;
            },

            getDebouncedListingsPaged: debounce(function () {
                this.getListingsPaged();
            }, 500),

            goToUrl(url) {
                window.location.href = url;
            },

            saveFilters() {
                try {
                    localStorage.setItem(
                        `categoryFilters-${this.serviceArea.id}`,
                        JSON.stringify(this.categoryFilters)
                    );

                    // Update home filters with current category names
                    const selectedCategories = this.categories
                        .filter(category => this.categoryFilters.includes(category.id))
                        .map(category => category.name);

                    localStorage.setItem('home-categoryFilters', JSON.stringify(selectedCategories));
                } catch (error) {
                    console.error('Error saving filters:', error);
                }
            },


            async loadFilters() {
                this.resourceTypeFilters = (await localStorage.getItem('resourceTypeFilters-' + this.serviceArea.id)) || [];
                this.categoryFilters = (await localStorage.getItem('categoryFilters-' + this.serviceArea.id)) || [];
            },

            updateHomeCategoryFilters(categoryId, event) {
                const category = this.categories.find(c => c.id === categoryId);
                if (!category) return;

                let homeFilters = JSON.parse(localStorage.getItem('home-categoryFilters')) || [];

                if (event) {
                    // Add category name to home filters if checked
                    if (!homeFilters.includes(category.name)) {
                        homeFilters.push(category.name);
                    }
                } else {
                    // Remove category name from home filters if unchecked
                    homeFilters = homeFilters.filter(name =>
                        name.toLowerCase() !== category.name.toLowerCase()
                    );
                }

                localStorage.setItem('home-categoryFilters', JSON.stringify(homeFilters));
            },

            syncCategoryFiltersWithHome() {
                // Update the local storage to sync with the home page filters
                localStorage.setItem('home-categoryFilters', JSON.stringify(this.categoryFilters));
            },
        },
    };
</script>

<style scoped>
/* No custom checkbox styling needed - handled by DCheckbox component */
</style>
